// src/login/Login.js
import { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import axios from 'axios';
import IconsSubmit from '../components/styled/IconsSubmit';
import { BsEye } from 'react-icons/bs';
import {BsEyeSlash }from 'react-icons/bs';
import { API_URL_AUTH } from '../creds';

const Login = () => {
  const { showToast } = useContext(GlobalContext);
  const [emailAddress, setEmailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showToast('pending', 'Logging you in…', 'top', 10);

    try {
      const response = await axios.post(`${API_URL_AUTH}/userAuthLogin`, {
        username: emailAddress,
        password: password,           // ← this was the bug (extra { })
      });

      const data = response.data;

      if (data.access_token) {
        localStorage.setItem('avatarUser', JSON.stringify(data));
        localStorage.setItem('expirationTime', Date.now() + 10 * 60 * 1000);
        showToast('success', 'Login successful!', 'top', 5);
        window.location.replace('/');
      } else {
        showToast('error', data.message || 'Invalid credentials', 'top', 8);
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        error.message ||
        'Something went wrong';
      showToast('failure', msg, 'top', 10);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
      <div className="bg-white rounded-2xl p-8 border border-gray-200
                shadow-[0_0_20px_rgba(0,0,0,0.24)]">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
            Welcome Back
          </h1>

          <form onSubmit={handleLogin} className="space-y-6">
            {/* Email */}
            <div className="relative">
              <input
                type="email"
                value={emailAddress}
                onChange={(e) => setEmailAddress(e.target.value)}
                required
                className="peer w-full px-4 py-4 text-gray-900 bg-transparent border-2 border-gray-400 rounded-xl focus:border-blue-600 focus:outline-none transition-all duration-300 placeholder-transparent"
                placeholder="Email"
              />
              <label
                className={`absolute left-4 -top-2.5 px-2 bg-white text-sm font-medium text-gray-900 transition-all duration-300 peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-600 peer-focus:-top-2.5 peer-focus:text-blue-600 peer-focus:text-sm ${emailAddress ? '-top-2.5 text-blue-600 text-sm' : ''}`}
              >
                Email Address
              </label>
            </div>

            {/* Password */}
            <div className="relative">
              <input
                type={isPasswordVisible ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="peer w-full px-4 py-4 pr-12 text-gray-900 bg-transparent border-2 border-gray-400 rounded-xl focus:border-blue-600 focus:outline-none transition-all duration-300 placeholder-transparent"
                placeholder="Password"
              />
              <label
                className={`absolute left-4 -top-2.5 px-2 bg-white text-sm font-medium text-gray-600 transition-all duration-300 
                  peer-placeholder-shown:top-4 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-600 
                  peer-focus:-top-2.5 peer-focus:text-blue-600 peer-focus:text-sm
                  ${password ? '-top-2.5 text-blue-600 text-sm' : ''}`}
              >
                Password
              </label>

              <button
                type="button"
                onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
              >
                {isPasswordVisible ? <BsEye size={22} /> : <BsEyeSlash size={22} />}
              </button>
            </div>

            {/* Forgot Password */}
            <div className="text-right">
              <Link
                // to="/forgotPassword"
                className="text-sm font-medium text-blue-600 hover:text-blue-800 hover:underline"
              >
                Forgot Password?
              </Link>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full py-4 rounded-xl font-semibold text-lg text-white transition-all duration-300 shadow-lg
                ${isLoading
                  ? 'bg-blue-400 cursor-not-allowed'
                  : 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 hover:shadow-2xl hover:-translate-y-0.5'}`}
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <IconsSubmit />
                  Logging in…
                </span>
              ) : (
                'Login'
              )}
            </button>
          </form>

          <p className="mt-8 text-center text-gray-600">
            Don’t have an account?{' '}
            <Link
              // to="/register"
              className="font-semibold text-blue-600 hover:text-blue-800 hover:underline"
            >
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
